import { Badge } from '@amzn/awsui-components-console';
import { PostConferenceMergeStatus } from '@amzn/awsdev-docs-virtual-smiley-conference-typescript-client';

// Badge for a row's post-conference merge status (694). Color signals outcome:
//   blue  = NOTIFICATION_SENT         (merge reminder sent, informational)
//   green = AUTO_MERGE_SUCCEEDED      (auto-merged, no action needed)
//   red   = AUTO_MERGE_FAILED         (needs attention)
//   grey  = SKIPPED_NOTHING_TO_MERGE  (conference commit already on the publishing branch — nothing to merge)
// An absent status (the common case) means the package hasn't been processed yet — shown as a
// dash. Grey also serves as the forward-compat fallback: if the backend adds a new status value
// before this UI is updated, we render the raw string in grey rather than crash or show nothing.
// Keyed on the string value (not enum members) so a new value degrades gracefully. The raw enum
// value is rendered as the label, consistent with the sibling AncestryBadge and
// ActivePackageStatusBadge in this table.
const MERGE_STATUS_COLORS: Record<string, 'blue' | 'grey' | 'green' | 'red'> = {
  NOTIFICATION_SENT: 'blue',
  AUTO_MERGE_SUCCEEDED: 'green',
  AUTO_MERGE_FAILED: 'red',
  SKIPPED_NOTHING_TO_MERGE: 'grey',
};

export const PostConferenceMergeStatusBadge = ({
  status,
}: {
  status?: PostConferenceMergeStatus | string;
}) => {
  if (!status) {
    return <>-</>;
  }
  const color = MERGE_STATUS_COLORS[status] ?? 'grey';
  return <Badge color={color}>{status}</Badge>;
};
